<div id="loading-wrapper">
  <div id="loading-text">{{'LOADING..' | translate}}</div>
  <div id="loading-content"></div>
</div>
